import jwt_decode from 'jwt-decode';

export function getDecodedToken(token: string | null): Record<string, unknown> | null {
  try {
    if (!token) {
      return null;
    }

    return jwt_decode(token) as Record<string, unknown>;
  } catch (Error) {
    return null;
  }
}
